import type { EChartsOption } from 'echarts';

import { buildAnimationConfig } from '../shared/animation';
import { buildGaugeSeries } from './series';
import type { GaugeChartConfig } from './types';

export const buildGaugeChartOption = (value: number, config: GaugeChartConfig): EChartsOption => ({
  ...buildAnimationConfig(config.animated),
  series: [buildGaugeSeries(value, config)],
});
